<template>
  <v-footer
    class="footer"
    height="60"
    color="#fff"
  >
    <v-layout align-center justify-center>
      <v-flex xs12 text-xs-center>
        &copy; {{new Date().getFullYear()}} — <span class="font-weight-regular">Ш++ | Peer-To-Peer</span>
      </v-flex>
    </v-layout>
  </v-footer>
</template>

<script>
  export default {
    name: "Footer"
  }
</script>

<style>
  footer {
    border-top: 2px solid #4CAF50 !important;
    background-color: #fff;
  }
</style>